<template>
<div class="persons-wrapper">
  <BaseCropper v-show="showCropper" @close="showCropper = false" @captured="photosSelected.push($event)" :img-url="selectedImg"/>
  <el-dialog
    :key="rerenderkey + 2"
    :show-close="false"
    :visible.sync="createPersonModal.showSuccess"
    width="568px">
    <div class="close-video" @click="createPersonModal = { showSuccess: false }" style="background-color: transparent;color: #00204D;">
      <svgicon name="Close"></svgicon>
    </div>
    <div class="settings-form__success">
      <img src="../../assets/img/success-persons.svg" alt="">
    </div>
  </el-dialog>
  <el-dialog
    :key="rerenderkey + 1"
    :show-close="false"
    :visible.sync="createPersonModal.open"
    top="20px"
    width="568px">
    <div slot="title" class="acr-bold-22">Add Person’s Info</div>
    <div class="close-video" @click="createPersonModal = { open: false, showSuccess: false }" style="background-color: transparent;color: #00204D;">
      <svgicon name="Close"></svgicon>
    </div>
    <div class="settings-form" v-if="createPersonModal.open">
      <div class="settings-field">
        <div class="settings-label acr-bold-18">
          Name
        </div>
        <input type="text" class="settings-input" placeholder="Write a name" v-model="nameSelected">
      </div>
      <div class="settings-field">
        <div class="settings-label acr-bold-18">
          Select tag(s)
        </div>
        <div class="settings-tags">
          <div class="settings-tag"
               :class="{'active': tagsSelected.includes(item)}"
               @click="tagsSelected.includes(item) ? tagsSelected = tagsSelected.splice(index, 1) : tagsSelected.push(item)"
               v-for="(item, index) in tagsAvailable" :key="item + index">{{item}}</div>
          <el-popover
            :visible-arrow="false"
            placement="bottom-start"
            popper-class="persons-footer__preview-pop"
            transition="none"
            width="261"
            :close-delay="0"
            v-model="addTag.visible"
            trigger="click">
            <div class="persons-footer__preview-pop-head">
              <span>Create new tag</span>
              <svgicon name="Close" @click="cancelSelection(addTag)"></svgicon>
            </div>
            <div class="persons-footer__preview-pop-body">
              <div style="display:flex;">
                <input type="text" v-model="addTag.value">
                <div class="settings-tag__add-confirm" @click="addNewTag">
                  <svgicon name="Arrow-right"></svgicon>
                </div>
              </div>
            </div>
            <div class="settings-tag settings-tag__add" slot="reference">
              <span>+</span>
            </div>
          </el-popover>


        </div>
      </div>
      <div class="settings-field" v-if="photosSelected.length > 0">
        <div class="settings-label acr-bold-18">
          Selected photo(s)
        </div>
        <div class="settings-previews">
          <div  v-for="item in mappedPhotos" :key="item.url" style="position: relative">
            <template :scope="item">
              <el-popover
                :visible-arrow="false"
                placement="right-start"
                popper-class="persons-footer__preview-pop"
                transition="none"
                :offset="-50"
                width="250"
                :close-delay="0"
                @after-enter="selectedToDelete = item.url"
                @hide="selectedToDelete = ''"
                v-model="item.visible"
                trigger="click">
                <div class="persons-footer__preview-pop-head">
                  <span>Delete this photo</span>
                  <svgicon name="Close" @click="cancelSelection(item)"></svgicon>
                </div>
                <div class="persons-footer__preview-pop-body">
                  <div class="persons-footer__preview-pop-btn" @click="cancelSelection(item)">Cancel</div>
                  <div class="persons-footer__preview-pop-btn red" @click="removePhotoFromSelected(item)">Delete</div>
                </div>
                <div class="persons-footer__preview" slot="reference">
                  <img :src="item.url" alt=""
                       class="persons-footer__preview-img"
                       :class="{'persons-footer__preview--delete': selectedToDelete === item.url}">
                  <svgicon name="Delete" :class="{'persons-footer__preview--delete': selectedToDelete === item.url}"></svgicon>
                </div>
              </el-popover>
            </template>
          </div>
        </div>
      </div>
    </div>
    <div class="persons-modal__footer" slot="footer">
      <div class="persons-modal__btn" @click="createPersonModal = { open: false, showSuccess: false }">Cancel</div>
      <div class="persons-modal__btn grey" :class="{'green': nameSelected.length > 0}" @click.prevent="createNewPerson">Create person</div>
    </div>
  </el-dialog>
  <el-dialog
    :key="rerenderkey + 3"
    :show-close="false"
    :visible.sync="deletePersonModal.open"
    width="568px">
    <div slot="title" class="acr-bold-22" style="max-width: 308px">Are you sure you want to delete this person?</div>
    <div class="close-video" @click="deletePersonModal = { open: false }" style="background-color: transparent;color: #00204D;">
      <svgicon name="Close"></svgicon>
    </div>
    <div class="persons-group__card" style="margin-bottom: 30px">
      <img src="../../assets/img/abbie.png" alt="" class="persons-group__img">
      <div style="flex-grow: 1">
        <div class="persons-group__name acr-bold">Abbie</div>
        <div class="persons-group__tags">
          <div class="persons-group__tag">Asd</div>
          <div class="persons-group__tag">Qwexzc</div>
        </div>
      </div>
    </div>
    <div class="persons-modal__footer" slot="footer">
      <div class="persons-modal__btn" @click="deletePersonModal = { open: false }">Cancel</div>
      <div class="persons-modal__btn grey red" @click.prevent="deletePersonModal = { open: false }">Delete person</div>
    </div>
  </el-dialog>
  <div class="persons">
    <div class="persons-header">
      <div class="persons-header__add">
        <input type="file" class="persons-header__add-upload" accept="image/jpeg,image/png" @change="uploadPhoto">
        <div class="persons-header__btn">
          <svgicon name="Plus"></svgicon>
        </div>
        <div class="persons-header__title acr-bold-18" style="margin-top: -2px;margin-right: 17px">Add Person</div>
      </div>
      <div class="persons-header__tabs">
        <div class="persons-header__tab active acr-bold">
          <svgicon name="Done-all"></svgicon>
          <span>Tagged Persons</span>
        </div>
        <div class="persons-header__tab acr-bold disabled">
          <svgicon name="crop"></svgicon>
          <span>Undetected Persons</span>
        </div>
      </div>
    </div>
      <div class="persons-tags__cloud">
        <div class="persons-tags__scroll" @click="scrollTags">
          <svgicon name="Chevron-right"></svgicon>
        </div>
        <div class="persons-tags__horizontal" ref="tagScrollable">
          <div class="persons-tags__tag" v-for="item in tagsAvailable" :key="item">{{item}}</div>
        </div>
        <div class="persons-tags__search">
          <input type="text" class="persons-tags__search-input" placeholder="Search" v-model="search">
        </div>
      </div>
      <transition name="fade">
        <div class="persons-group__title acr-bold sticky" v-if="intersectingCard && scrolledPercent > 35">{{intersectingCard}}</div>
      </transition>
      <div class="persons-alphabet">
        <div class="persons-alphabet__char"
             v-for="item in alphabet"
             :key="item"
             @click="goto(item)"
             :class="{'active': intersectingCard === item}">
          {{item}}
        </div>
      </div>

    <BaseScrollbar>
          <div class="persons-content content-wrapper " @scroll="handleScroll">
            <div v-for="item in groupedPersons" :key="item.alphabet + '1000'" :ref="item.alphabet" :data-attr="item.alphabet">
              <div class="persons-group__title acr-bold">{{item.alphabet}}</div>
              <div class="persons-group">
                <div class="persons-group__card" @click="$router.push('/persons/2')" v-for="person in item.record" :key="person.id + '2000'">
                  <img :src="person.url" alt="" class="persons-group__img">
                  <div style="flex-grow: 1">
                    <div class="persons-group__name acr-bold">{{person.title.substring(0,8)}}</div>
                    <div class="persons-group__tags">
                      <div class="persons-group__tag">Asd</div>
                      <div class="persons-group__tag">Qwexzc</div>
                    </div>
                  </div>
                  <div class="persons-group__options">
                    <el-dropdown trigger="hover" placement="bottom" @command="handleCardCommand">

                      <div >
                        <svgicon name="More2" style="width: 16px;height: 16px;"></svgicon>

                        <el-dropdown-menu slot="dropdown">
                          <el-dropdown-item command="edit">Edit person</el-dropdown-item>
                          <el-dropdown-item command="delete">Delete person</el-dropdown-item>
                        </el-dropdown-menu>
                      </div>
                    </el-dropdown>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </BaseScrollbar>
    <portal to="app">
      <footer class="footer" style="padding-top: 21px" v-if="photosSelected.length > 0 && createPersonModal.open === false" :key="rerenderkey">
        <div class="footer-header">
          <div class="footer-title acr-bold-22">Selected photos</div>
          <div class="persons-footer__btn" @click="createPersonModal = { open: true }">Create person</div>
        </div>
        <div class="persons-footer">
          <div class="persons-footer__upload">
            <svgicon name="File-upload"></svgicon>
            <input type="file" class="persons-footer__upload-input" @change="uploadPhoto">
          </div>
          <div  v-for="item in mappedPhotos" :key="item.url" style="position: relative">
           <template :scope="item">
             <el-popover
               :visible-arrow="false"
               placement="right-start"
               popper-class="persons-footer__preview-pop"
               transition="none"
               :offset="-50"
               width="250"
               :close-delay="0"
               @after-enter="selectedToDelete = item.url"
               @hide="selectedToDelete = ''"
               v-model="item.visible"
               trigger="click">
               <div class="persons-footer__preview-pop-head">
                 <span>Delete this photo</span>
                 <svgicon name="Close" @click="cancelSelection(item)"></svgicon>
               </div>
               <div class="persons-footer__preview-pop-body">
                 <div class="persons-footer__preview-pop-btn" @click="cancelSelection(item)">Cancel</div>
                 <div class="persons-footer__preview-pop-btn red" @click="removePhotoFromSelected(item)">Delete</div>
               </div>
               <div class="persons-footer__preview" slot="reference">
                 <img :src="item.url" alt=""
                      class="persons-footer__preview-img"
                      :class="{'persons-footer__preview--delete': selectedToDelete === item.url}">
                 <svgicon name="Delete" :class="{'persons-footer__preview--delete': selectedToDelete === item.url}"></svgicon>
               </div>
             </el-popover>
           </template>
          </div>
        </div>
      </footer>
    </portal>
  </div>
</div>
</template>

<script>
import {
  // getAllPersons,
  // createPerson,
  deletePersonById } from "../../api/persons";
import BaseScrollbar from '../../components/BaseScrollbar';
import BaseCropper from '../../components/BaseCropper';
import { mapGetters } from 'vuex';

export default {
  name: "Settings",
  components: { BaseScrollbar, BaseCropper },
  data() {
    return {
      persons: [],
      tagsAvailable: [
        "Camera operator",
        "Careers adviser",
        "Careers consultant",
        "Cartographer",
        "Catering manager",
        "Charities administrator",
        "Chiropractor",
      ],
      tagsSelected: [],
      nameSelected: '',
      photosSelected: [],
      selectedToDelete: '',
      selectedImg: '',
      showCropper: false,
      intersectingCard: null,
      scrolledPercent: 0,
      rerenderkey: 0,
      search:'',
      alphabet: [...'abcdefghijklmnopqrstuvwxyz'],
      createPersonModal: {
        open: false,
        showSuccess: false,
      },
      deletePersonModal: {
        open: false,
      },
      addTag: { visible: false, value: '' }
    }
  },
  computed: {
    ...mapGetters({
      projectTypes: 'projectTypes',
    }),
    confirmActive() {
      return this.photosSelected.length > 0 && this.nameSelected.trim().length > 0
    },
    mappedPhotos() {
      if (this.photosSelected.length === 0) return []
      return this.photosSelected.map((i) => ({ url: i, visible: false }))
    },
    groupedPersons() {
      const personsArr = this.searchActive
        ? this.persons.filter((i) => i.title.toLowerCase().indexOf(this.search.trim().toLowerCase()) > -1)
        : this.persons

      const result = personsArr.reduce((acc, curr) => {
        const idx = acc.findIndex(e => e.alphabet === curr.title[0]);
        if (idx === -1) {
          acc.push({ alphabet: curr.title[0], record: [curr] });
        }
        else {
          acc[idx].record.push(curr);
          acc[idx].record.sort((r1, r2) => r1.title > r2.title ? 1 : -1);
        }
        return acc;
      }, []).sort((e1, e2) => e1.alphabet > e2.alphabet ? 1 : -1);

      return result
    },
    searchActive() {
      return this.search.trim().length > 0
    }
  },

  beforeRouteEnter(to, from, next) {
    next((vm) => {
      if (vm.projectTypes.includes('video_analytics')) {
        next()
      } else {
        next('/dashboard')
      }
    })
  },

  created() {
    this.fetchPersons();
  },

  methods: {
    handleScroll(e) {
      const container = e.target
      const containerTop = e.target.scrollTop

      const top = this.alphabet.filter((el) => {
        return (this.$refs[el] ? this.$refs[el][0].offsetTop : containerTop + 21) <= containerTop + 20
      });

      this.scrolledPercent = container.scrollTop
      this.intersectingCard = top[top.length - 1]
    },
    fetchPersons() {
      fetch('https://jsonplaceholder.typicode.com/albums/1/photos')
        .then(response => response.json())
        .then(json => {
          this.persons = json.map((item) => ({ ...item, title: item.title.substring(0, 8) }))
        })
      // getAllPersons().then((res) => {
      //   this.persons = res.data.persons;
      // })
    },
    cancelSelection() {
      this.rerenderkey += 1
    },
    addNewTag() {
      this.tagsAvailable.push(this.addTag.value)
      this.addTag = { visible: false, value: '' }
    },
    removePhotoFromSelected(photo) {
      console.log(photo)
      this.photosSelected = this.photosSelected.filter((i) => photo.url !== i)
    },
    uploadPhoto(e) {
      this.selectedImg = this.getPhotoUrl(e.target.files[0]);
      this.showCropper = true;
      // this.photosSelected.push(e.target.files[0]);
    },
    getPhotoUrl(file) {
      return URL.createObjectURL(file)
    },
    handleCardCommand(command) {
      if (command === 'edit') {
        this.createPersonModal = { open : true }
      } else {
        this.deletePersonModal = { open: true }
      }
    },
    createNewPerson() {
      this.createPersonModal = { showSuccess : true }
      this.photosSelected = []
      setTimeout(() => {
        this.createPersonModal = { showSuccess: false, open: false }
      }, 5000)
      // const photo = e.target.files[0];
      // const formD = new FormData();
      // const name = prompt('Person name');
      //
      // if (!name) return;
      //
      // formD.append('file_in', photo);
      // formD.append('person_name', name);
      //
      // createPerson(formD).then(() => this.fetchPersons());
    },
    removePerson(id) {
      deletePersonById(id).then(() => this.fetchPersons());
    },
    goto(refName) {
      if (!this.$refs[refName]) return;

      const el = this.$refs[refName][0];
      el.scrollIntoView()
      window.document.body.scrollTop = 0
    },
    scrollTags() {
      const container = this.$refs.tagScrollable
      const targetScrollPosition = container.scrollWidth - container.offsetWidth === container.scrollLeft ? 0 : container.scrollLeft + container.offsetWidth
      container.scrollTo({
        top: 0,
        left: targetScrollPosition,
        behavior: 'smooth'
      })
    },
  },
}
</script>

<style scoped>

</style>
